<div class="grid">
  <div class="col-12">
    The calendars below show the current order availability dates for both transported and driven
    movements
  </div>

  <!-- show calendar for driven moves -->
  <div class="col-6">
    <div class="align-center mb-2">Driven Availability</div>
    <app-full-calendar [eventData]="drivenLimits" [calendarName]="'fc1'"> </app-full-calendar>
  </div>

  <!-- show calendar for transported moves -->
  <div class="col-6">
    <div class="align-center mb-2">Transported Availability</div>
    <app-full-calendar [eventData]="transportLimits" [calendarName]="'fc2'"
      >app-
    </app-full-calendar>
  </div>
</div>

<!--        (calendarEventChanged)="calendarEventChanged($event)"-->
<!--        (calendarViewChanged)="calendarViewChanged($event)"-->
<!--        (calendarDateClicked)="calendarDateClicked($event)"-->
<!--        (calendarDayHeaderSelected)="calendarDayHeaderSelected($event)"-->
